/* eslint-disable import/no-duplicates */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
import React, { useContext, useEffect, useState } from 'react';

import { useRouter } from 'next/router';
import Image from 'next/image';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import MenuArrowSVG from '../icons/menu-arrow.svg';
import BurgerMenuSVG from '../icons/menuIcon.svg';
import { HeaderContext } from '../../../contexts/headerContext';
import useMenu from '../../../hooks/useMenu';
import MobileAppList from './MobileAppList';
import { useFirebase } from '../../../contexts/ssr-firebase-context';
import { useUser } from '../../../contexts/ssr-user-context';

const nIASlegaCyRedirectList = ['/student'];

function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const [activeRoute, setActiveRoute] = useState(router.pathname);
  const { getConfigValue, loading } = useFirebase();
  const { user } = useUser();
  const webHomeMenus = getConfigValue('webHomeMenus');
  const webMobileAppDownloadList = getConfigValue('webMobileAppDownloadList');
  const { setShowLogoutPopup } = useContext(HeaderContext);
  const [menuList, setMenuList] = useState([]);
  const localMenus = useMenu(user);

  useEffect(() => {
    if (webHomeMenus?.hamburgerMenus) {
      const visibleMenus = localMenus
        .filter((localItem) => localItem.visibility)
        .map((localItem) => {
          const remoteItem = webHomeMenus.hamburgerMenus.find((remote) => remote.label === localItem.label);
          return remoteItem ? { ...remoteItem, icon: localItem.icon, iconFill: localItem.iconFill } : null;
        })
        .filter(Boolean);
      setMenuList(visibleMenus);
    }
  }, [webHomeMenus]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = (route, label, legacyPage) => {
    // console.log('route, label', route, label)
    if (label === 'Logout') {
      setShowLogoutPopup(true);
    } else if (nIASlegaCyRedirectList.some((prefix) => route.startsWith(prefix)) || legacyPage === true) {
      const host = window.location.origin;
      const url = `${host}${route}`;
      window.open(url);
    } else {
      router.push(route);
    }
  };

  if (loading) {
    return (
      <div className="relative">
        {/* Hamburger Icon */}
        <button
          className="lg:hidden flex items-center justify-center w-10 h-10 rounded-md focus:outline-none"
          onClick={toggleMenu}
        >
          <div className="space-y-1">
            <Image className="w-6 h-6 lg:w-[30px] lg-h-[30px]" width={30} height={30} alt="hamburgermennu" src={BurgerMenuSVG} />
          </div>
        </button>
      </div>
    );
  }

  return (
    <div className="relative">
      {/* Hamburger Icon */}
      <button
        className="lg:hidden flex items-center justify-center w-10 h-10 rounded-md focus:outline-none"
        onClick={toggleMenu}
      >
        <div className="space-y-1">
          <Image className="w-6 h-6 lg:w-[30px] lg-h-[30px]" width={30} height={30} src={BurgerMenuSVG} alt="togglemenu" />
        </div>
      </button>

      {/* Slide-in Menu */}
      <div
        className={`fixed top-0 left-0 h-full bg-white shadow-md transform ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300`}
        style={{ width: '80vw', zIndex: '2' }}
      >
        {/* Profile Section */}
        <div className="flex items-center p-4 border-b border-gray-200">
          {/* <UserCircleIcon width={50} height={50} /> */}
          {user?.profile?.accountDetails?.profilePicture
            ? (
              <Image
                width={50}
                height={50}
                src={user?.profile?.accountDetails?.profilePicture}
                alt="Profile"
                className="w-12 h-12  object-cover rounded-full ring-2 ring-gray-300 dark:ring-gray-500"
              />
            )
            : <UserCircleIcon width={50} height={50} />}
          <div className="ml-4">
            <h4 className="text-lg font-medium text-gray-800">
              {user?.name}
            </h4>
            <p className="text-sm text-gray-500">
              {user?.email}
            </p>
          </div>
        </div>

        <ul className="mt-4">
          {menuList?.map((item, index) => (
            <li
              key={item?.label}
              onClick={() => {
                handleNavigate(item?.route, item?.label, item?.isLegacyPage);
                setActiveRoute(item?.route);
              }}
                // eslint-disable-next-line react/jsx-props-no-multi-spaces
              className={`flex items-center px-4 py-3 cursor-pointer ${
                activeRoute === item.route
                  ? 'bg-lightThinBlue text-customBlue'
                  : 'text-grayLight hover:bg-lightThinBlue hover:text-customBlue'
              }`}
            >
              <Image
                width={30}
                height={30}
                className="material-icons text-gray-600"
                src={
                    activeRoute === item.route
                      ? menuList[index].iconFill
                      : menuList[index].icon
                  }
                alt={`${item.label} Icon`}
              />
              <span className="ml-4 flex-grow">{item.label}</span>
              <span className="text-gray-400">
                <Image width={30} height={30} src={MenuArrowSVG} alt="arrow" />
              </span>
              {/* Add the right arrow */}
            </li>
          ))}
        </ul>
        <MobileAppList appdata={webMobileAppDownloadList} />
      </div>

      {/* Overlay (optional, to close menu when clicked outside) */}
      {isOpen && (
        <div
          //   className="fixed inset-0 bg-black bg-opacity-50 sm:hidden"
          className="fixed inset-0 lg:hidden"
          onClick={toggleMenu}
        />
      )}
    </div>
  );
}

export default HamburgerMenu;
